/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AddMediaToVOPRequest} from "../model/add-media-to-vop-request";
import {CreateByNameRequest} from "../model/create-by-name-request";
import {DeleteBatchVOPSetRequest} from "../model/delete-batch-vop-set-request";
import {DeleteVOPSetRequest} from "../model/delete-vop-set-request";
import {DuplicateVOPSetRequest} from "../model/duplicate-vop-set-request";
import {ListData} from "../model/list-data";
import {SuccessCreateResponse} from "../model/success-create-response";
import {SuccessResponse} from "../model/success-response";
import {VTPSet} from "../model/vtp-set";

@Injectable({
    providedIn: "root",
})
export class SimVopSetService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public addMediaToVopSet(args: AddMediaToVOPRequest) {
        return super.post<void>(`/api/VopSet/AddMediaToVopSet`, args);
    }

    public createVopset(vopSetRequest: CreateByNameRequest) {
        return super.post<SuccessCreateResponse>(`/api/VopSet/CreateVopset`, vopSetRequest);
    }

    public deleteBatchVopSet(request: DeleteBatchVOPSetRequest) {
        return super.post<SuccessResponse>(`/api/VopSet/DeleteBatchVopSet`, request);
    }

    public deleteVopSet(request: DeleteVOPSetRequest) {
        return super.post<SuccessResponse>(`/api/VopSet/DeleteVopSet`, request);
    }

    public downloadVOPSet_Url(vopSetId: string) {
        return super.getUrl(`/api/VopSet/DownloadVOPSet`, {vopSetId: vopSetId});
    }

    public duplicateVopSet(vopSetRequest: DuplicateVOPSetRequest) {
        return super.post<SuccessResponse>(`/api/VopSet/DuplicateVopSet`, vopSetRequest);
    }

    public getDefaultVopSet() {
        return super.get<VTPSet>(`/api/VopSet/GetDefaultVopSet`, );
    }

    public getFilteredVopSets(searchTerm: string = null, searchColumn: string = "name", sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<VTPSet>>(`/api/VopSet/GetFilteredVopSets`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getVOPSetById(vopSetId: string) {
        return super.get<VTPSet>(`/api/VopSet/GetVOPSetById`, {vopSetId: vopSetId});
    }

    public listVOPSets(searchTerm: string = null, sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<VTPSet>>(`/api/VopSet/ListVOPSets`, {searchTerm: searchTerm, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public saveVopSet(vopSet: VTPSet) {
        return super.post<SuccessResponse>(`/api/VopSet/SaveVopSet`, vopSet);
    }
}